var consumer = {
  "units": {
    "Wh": {
      "single": "vatio-hora",
      "plural": "vatios-hora",
      "annotated_abv": "(Wh)",
      "abv": "Wh",
      "definition": "La generación y el uso de energía se miden en vatios-hora (Wh). Un kilovatio-hora (kWh) equivale a 1000 varios-hora y encarna la unidad que utilizan los proveedores de suministro de electricidad en las facturas mensuales."
    },
    "kWh": {
      "single": "kilovatio-hora",
      "plural": "kilovatios-hora",
      "annotated_abv": "(kWh)",
      "abv": "kWh"
    },
    "MWh": {
      "single": "megavatio-hora",
      "plural": "megavatios-hora",
      "annotated_abv": "(MWh)",
      "abv": "MWh"
    },
    "GWh": {
      "single": "gigavatio-hora",
      "plural": "gigavatios-hora",
      "annotated_abv": "(GWh)",
      "abv": "GWh"
    },
    "TWh": {
      "single": "teravatio-hora",
      "plural": "teravatios-hora",
      "annotated_abv": "(TWh)",
      "abv": "TWh"
    },
    "PWh": {
      "single": "petavatio-hora",
      "plural": "petavatios-hora",
      "annotated_abv": "(PWh)",
      "abv": "PWh"
    },
    "EWh": {
      "single": "exavatio-hora",
      "plural": "exavatios-hora",
      "annotated_abv": "(EWh)",
      "abv": "EWh"
    },
    "ZWh": {
      "single": "zettavatio-hora",
      "plural": "zettavatios-hora",
      "annotated_abv": "(ZWh)",
      "abv": "ZWh"
    },
    "YWh": {
      "single": "yottavatio-hora",
      "plural": "yottavatios-hora",
      "annotated_abv": "(YWh)",
      "abv": "YWh"
    },
    "W": {
      "single": "vatio",
      "plural": "vatios",
      "annotated_abv": "(W)",
      "abv": "W"
    },
    "kW": {
      "single": "kilovatio",
      "plural": "kilovatios",
      "annotated_abv": "(kW)",
      "abv": "kW"
    },
    "MW": {
      "single": "megavatio",
      "plural": "megavatios",
      "annotated_abv": "(MW)",
      "abv": "MW"
    },
    "GW": {
      "single": "gigavatio",
      "plural": "gigavatios",
      "annotated_abv": "(GW)",
      "abv": "GW"
    },
    "TW": {
      "single": "teravatio",
      "plural": "teravatios",
      "annotated_abv": "(TW)",
      "abv": "TW"
    },
    "PW": {
      "single": "petavatio",
      "plural": "petavatios",
      "annotated_abv": "(PW)",
      "abv": "PW"
    },
    "EW": {
      "single": "exavatio",
      "plural": "exavatios",
      "annotated_abv": "(EW)",
      "abv": "EW"
    },
    "ZW": {
      "single": "zettavatio",
      "plural": "zettavatios",
      "annotated_abv": "(ZW)",
      "abv": "ZW"
    },
    "YW": {
      "single": "yottavatio",
      "plural": "yottavatios",
      "annotated_abv": "(YW)",
      "abv": "YW"
    },
    "percent": {
      "single": "por ciento",
      "plural": "por ciento",
      "annotated_abv": "%",
      "abv": "%"
    },
    "minutes": {
      "zero": "minutos",
      "ltone": "minuto",
      "single": "minuto",
      "plural": "minutos"
    },
    "hours": {
      "zero": "horas",
      "ltone": "hora",
      "single": "hora",
      "plural": "horas"
    },
    "months": {
      "zero": "meses",
      "ltone": "mes",
      "single": "mes",
      "plural": "meses"
    },
    "years": {
      "zero": "años",
      "ltone": "año",
      "single": "año",
      "plural": "años"
    },
    "days": {
      "zero": "días",
      "ltone": "día",
      "single": "día",
      "plural": "días"
    },
    "nights": {
      "zero": "noches",
      "ltone": "noche",
      "single": "noche",
      "plural": "noches"
    },
    "batteries": {
      "zero": "pilas",
      "ltone": "pila",
      "single": "pila",
      "plural": "pilas"
    },
    "trees": {
      "zero": "árboles",
      "ltone": "árbol",
      "single": "árbol",
      "plural": "árboles"
    },
    "kg": {
      "zero": "kg",
      "ltone": "kg",
      "single": "kg",
      "plural": "kgs"
    },
    "laps": {
      "zero": "vueltas",
      "ltone": "vuelta",
      "single": "vuelta",
      "plural": "vueltas"
    },
    "barrels": {
      "zero": "barriles",
      "ltone": "barril",
      "single": "barril",
      "plural": "barriles"
    },
    "flights": {
      "zero": "vuelos",
      "ltone": "vuelo",
      "single": "vuelo",
      "plural": "vuelos"
    },
    "launches": {
      "zero": "lanzamientos",
      "ltone": "lanzamiento",
      "single": "lanzamiento",
      "plural": "lanzamientos"
    }
  },
  "timeAgo": {
    "now": "Ahora",
    "second": {
      "single": "Hace 1 segundo",
      "plural": "Hace %{number} segundos"
    },
    "minute": {
      "single": "Hace 1 minuto",
      "plural": "Hace %{number} minutos"
    },
    "hour": {
      "single": "Hace 1 hora",
      "plural": "Hace %{number} horas"
    },
    "day": {
      "single": "Hace 1 día",
      "plural": "Hace %{number} días"
    },
    "week": {
      "single": "Hace 1 semana",
      "plural": "Hace %{number} semanas"
    },
    "month": {
      "single": "Hace 1 mes",
      "plural": "Hace %{number} meses"
    },
    "year": {
      "single": "Hace 1 año",
      "plural": "Hace %{number} años"
    }
  },
  "weather": {
    "unknown": "Climatología desconocida",
    "footer": "Datos climatológicos proporcionados por The Weather Company.",
    "credit": "Proporcionado por The Weather Company"
  },
  "reports": {
    "title": "Reportes",
    "submit": "Ejecutar reporte",
    "to": "a",
    "selectDate": "Select the date",
    "insufficientData": "Vuelva a comprobarlo mañana. La nube de Enphase no ha recopilado los datos necesarios para crear informes.",
    "1": {
      "name": "Generación diaria",
      "title": "Generación de energía del sitio",
      "description": "Resumen de la generación de energía diaria de este sitio. Puesto que este reporte proporciona datos de la energía por día, puede solicitar los días que desee hasta ayer."
    },
    "2": {
      "name": "Generación reciente",
      "title": "Generación de energía reciente del sitio",
      "description": "Resumen de la última semana de generación de energía de este sitio en incrementos de 5 minutos."
    },
    "6": {
      "name": "Generación mensual",
      "title": "Generación de energía mensual",
      "description": "Resumen de la generación de energía de un mes y la potencia máxima de este sitio."
    },
    "15": {
      "name": "Consumo diario",
      "title": "Consumo de energía del sitio",
      "description": "Resumen del consumo de energía diaria de este sitio. Puesto que este reporte proporciona datos de la energía por día, puede solicitar los días que desee hasta ayer."
    },
    "16": {
      "name": "Consumo reciente",
      "title": "Consumo de energía reciente del sitio",
      "description": "Resumen de la última semana de consumo de energía de este sitio en incrementos de 15 minutos."
    },
    "17": {
      "name": "Energía neta mensual",
      "title": "Energía neta mensual",
      "description": "En este reporte se resume la energía generada, consumida, importada y exportada de este sitio cada 15 minutos correspondiente al mes seleccionado. Si el sistema contiene baterías CA, el reporte también muestra la energía almacenada y descargada."
    },
    "19": {
      "name": "Reportes de la batería",
      "title": "Reportes de la batería",
      "description": "Este reporte proporciona los datos de la batería de los últimos 7 días"
    },
    "3": {
      "name": "Generación de energía en un día por módulo",
      "title": "Generación de energía en un día por módulo",
      "description": "Este reporte proporciona la generación de energía de todos los microinversores en la fecha especificada."
    },
    "5": {
      "name": "Generación de energía en un mes por módulo",
      "title": "Generación de energía en un mes por módulo",
      "description": "Este reporte proporciona la generación de energía de todos los microinversores en el mes especificado."
    },
    "20": {
      "name": "Informe de Autocomprobación de IQ-Relay",
      "title": "Informe de resultados de la Autocomprobación de IQ-Relay",
      "description": "Este informe proporciona los últimos resultados de la Autocomprobación de IQ-Relay"
    },
    "25": {
      "name": "Informe personalizado (en Wh)",
      "title": "Informe personalizado",
      "description": ""
    }
  },
  "stats": {
    "total": "Energía total",
    "peak_production": "Potencia máxima",
    "latest_production": "Última energía",
    "peak_consumption": "Consumo pico",
    "latest_consumption": "Último consumo",
    "recent_power": "Energía reciente",
    "maintainer": "Póngase en contacto con su responsable de mantenimiento",
    "enphase": "Ponerse en contacto con el soporte técnico de Enphase",
    "orenphase": "O póngase en contacto con el servicio de asistencia de Enphase",
    "learn_more": "Obtener más información.",
    "where": "¿Cuál es el problema?",
    "toGrid": "%{value} aproximadamente exportado a la red",
    "fromGrid": "%{value} aproximadamente importado de la red",
    "normal": {
      "title": "Normal",
      "modal": "El sistema está funcionando con normalidad."
    },
    "shortcomm": {
      "title": "La Gateway no está reportando",
      "hours": "Su sistema no ha reportado datos a la nube de Enphase durante las últimas %{horas} horas.",
      "date": "Su sistema no ha reportado datos a la nube de Enphase desde %{date}.",
      "unknown": "Este sistema no está informando a la nube de Enphase.",
      "question": "¿Ha dejado de funcionar su conexión a Internet?",
      "help_topic_link": "Vuelva a conectarse para consultar la actividad de su sistema.",
      "link": "Haga clic aquí para obtener ayuda."
    },
    "meter": {
      "title": "El medidor no genera reportes",
      "hours": "El medidor de su sistema no ha emitido reportes a la Gateway en las últimas %{hours} horas.",
      "date": "El medidor de su sistema no ha reportado a la Gateway desde %{date}.",
      "ct_wiring": "Hay un problema con las mediciones del medidor de la Gateway. Póngase en contacto con su responsable de mantenimiento para obtener ayuda.",
      "unknown": "El medidor de su sistema no está emitiendo reportes a la Gateway.",
      "link": "Haga clic aquí para obtener ayuda.",
      "modal": "Su medidor no ha reportado datos a la Gateway desde"
    },
    "meter_issue": {
      "title": "Problema del medidor",
      "ct_wiring": "Existe un problema con las medidas del medidor de su Envoy",
      "link": "Haga clic aquí para obtener ayuda."
    },
    "battery": {
      "title": "Las baterías CA no generan reportes",
      "modal": "Esta batería CA no está reportando de ningún dato.",
      "message": "Algunas baterías CA no están reportando de datos.",
      "messageSome": "Algunas baterías CA (%{count}) no están reportando de datos.",
      "link": "Haga clic aquí para obtener ayuda."
    },
    "storage_idle": {
      "title": "Almacenamiento inactivo",
      "modal": "Esta batería CA no está cargándose ni descargándose.",
      "date": "Al menos una batería CA no se ha cargado ni descargado desde %{date}.",
      "unknown": "Al menos una batería CA no está cargándose ni descargándose.",
      "link": "Haga clic aquí para obtener ayuda."
    },
    "encharge": {
      "title": "La batería no está reportando",
      "modal": "Esta batería no está reportando ningún dato.",
      "message": "La batería no está reportando ningún dato. Esto puede ocurrir si la comunicación inalámbrica entre su portal y la batería es débil. Puede tratarse de una falla temporal y debería solucionarse pronto.",
      "requestMaintainer": "Si el problema persiste, solicite ayuda a su encargado de mantenimiento.",
      "messageSome": "Algunas baterías (%{count}) no están reportando datos.",
      "link": "Haga clic aquí para obtener ayuda."
    },
    "enpower": {
      "title": "El Controlador del sistema no está reportando.",
      "modal": "Este Controlador del sistema no está reportando ningún dato.",
      "message": "El controlador del sistema no está reportando ningún dato. Esto puede ocurrir si la comunicación inalámbrica entre su portal y la batería el controlador del sistema es débil. Puede tratarse de una falla temporal y debería solucionarse pronto.",
      "requestMaintainer": "Si el problema persiste, solicite ayuda a su encargado de mantenimiento.",
      "messageSome": "Algunos Controladores del sistema (%{count}) no están reportando datos.",
      "link": "Haga clic aquí para obtener ayuda."
    },
    "encharge_issue": {
      "title": "Error de la batería",
      "modal": "Esta batería tiene un error.",
      "message": "La batería tiene un error."
    },
    "enpower_issue": {
      "title": "Error del Controlador del sistema",
      "modal": "Este Controlador del sistema tiene un error.",
      "message": "El Controlador del sistema tiene un error."
    },
    "micro": {
      "title": "Los microinversores no generan reportes",
      "modal": "Este microinversor no está reportando ningún dato a la Gateway.",
      "message": "Algunos microinversores no están reportando datos a la Gateway.",
      "messageSome": "Algunos microinversores (%{count}) no están reportando ningún dato a la Gateway.",
      "messageAll": "Ningún microinversor está reportando datos a la Gateway.",
      "link": "Haga clic aquí para obtener ayuda."
    },
    "power": {
      "title": "Problema de generación de sistema",
      "message": "Hay un problema de generación en su sistema.",
      "messageSome": "El microinversor está reportando de un problema de producción.",
      "messageThreshold": "El sistema está produciendo menos energía de la esperada.",
      "link": "Póngase en contacto con el servicio de soporte técnico de Enphase para obtener ayuda.",
      "maintainerlink": "Póngase en contacto con su responsable de mantenimiento para obtener ayuda."
    }
  }
};
module.exports = consumer;